import DomPurify from "isomorphic-dompurify";
import { ArrowRightCircle } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { FadeIn, FadeInStagger } from "components/ui/FadeIn";
import MaxWidthWrapper from "components/Tiles/commonComponents/MaxWidthWrapper";
import "./space.css";
type BlockProps = {
  title: string;
  bgColor: string;
  iconUrl: string;
  linkUrl?: string;
};

type SpaceCardsProps = {
  blocks?: BlockProps[];
  groupTitle?: string;
  groupSubtitle?: string;
  bgColor?: string;
  titleTag?: React.ElementType;
  miniTitle?: string;
  bigBoxTitle?: string;
  bigBoxBgColor?: string;
  bigBoxUrl?: string;
  bigBoxIcon: string;
  miniTitleTag?: React.ElementType;
};

const BalancedHTMLContent: React.FC<{ htmlContent: string }> = ({ htmlContent }) => {
  return <span dangerouslySetInnerHTML={{ __html: DomPurify.sanitize(htmlContent) }} />;
};

export default function SpaceCards({
  blocks,
  groupTitle,
  miniTitle,
  bigBoxTitle,
  bigBoxIcon,
  bigBoxBgColor,
  bigBoxUrl,
  titleTag = "h2",
  miniTitleTag = "h3",
  groupSubtitle,
  bgColor
}: SpaceCardsProps) {
  const TitleTag = titleTag;
  const MiniTitleTag = miniTitleTag;
  return (
    <section id="space-cards-105" style={{ backgroundColor: bgColor }}>
      <MaxWidthWrapper className="tile-container-y">
        <div className="tile-title-container">
          {miniTitle && <MiniTitleTag className="subby text-center">{miniTitle}</MiniTitleTag>}
          {groupTitle && (
            <TitleTag className="tile-main-header font-heading [text-wrap:balance]">
              <BalancedHTMLContent htmlContent={groupTitle} />
            </TitleTag>
          )}
          {groupSubtitle && <p className="text-lg">{groupSubtitle}</p>}
        </div>

        <FadeInStagger faster>
          <section className="grid grid-cols-2 gap-4 pb-4 sm:grid-cols-3 md:grid-cols-6 ">
            {blocks?.map((block, index) => (
              <FadeIn key={index}>
                <Link
                  href={block.linkUrl || ""}
                  key={index}
                  className="atom-link hoverable-space icon-styles grid transform cursor-pointer place-items-center rounded-2xl border px-4 py-6 shadow-sm  transition-transform duration-300"
                  style={{ backgroundColor: block.bgColor }}
                >
                  <div>
                    <div className="relative flex w-full justify-center pb-2">
                      <Image src={block.iconUrl} alt={`${block.title} Icon`} width={40} height={40} className="mb-2" />
                    </div>
                    <h3 className="font-matter text-md font-medium md:text-base">{block.title}</h3>
                    <ArrowRightCircle strokeWidth={2} color="#e5b04f" className="hover-icon" />
                  </div>
                </Link>
              </FadeIn>
            ))}
          </section>
        </FadeInStagger>
        <section className="w-full">
          <FadeIn>
            <Link
              href={bigBoxUrl || ""}
              className="atom-link hoverable-space icon-styles grid transform cursor-pointer place-items-center rounded-2xl border bg-[#ddd] p-4 py-12 shadow-sm  transition-transform duration-300"
              style={{ backgroundColor: bigBoxBgColor }}
            >
              <div>
                <div className="relative flex w-full justify-center pb-2">
                  {!!bigBoxIcon && (
                    <Image src={bigBoxIcon} alt="All Renovation Spaces" width={40} height={40} className="mb-2" />
                  )}
                </div>
                <h3 className="font-matter text-md  font-medium  md:text-base">{bigBoxTitle}</h3>
              </div>
            </Link>
          </FadeIn>
        </section>
      </MaxWidthWrapper>
    </section>
  );
}
